export default __webpack_public_path__ + "static/media/aerial view 7.953cfc29.jpeg";